import React, { useEffect } from "react";


export const CircleProgress = (props) => {
    const { topText, bottomText, maxNum, stNum } = props;

    // const maxNum = maxNum; //목표걸음수
    // const stNum = stNum; //남은걸음수
    const alNum = (1 / maxNum) * (maxNum - stNum);

    useEffect(() => {
        $('.incircle').circleProgress({
            startAngle: -Math.PI / 2,
            value: alNum,
            size: 400,
            thickness: 35,
            lineCap: 'round',
            emptyFill: "rgba(255,255,255,0.2)",
            fill: {
                gradient: ["#84d8c9", "#a6ace4"]
            }
        }).on('circle-animation-progress', function (event, progress, stepValue) {
            $(".progress-circle .info p").html(Math.round(maxNum - (stepValue * maxNum)));
            $(".progress-circle .info em").html(maxNum);
        });

        $(".incircle canvas").removeAttr("style");
    }, [maxNum, stNum]);

    return (
        <div className="progress-circle">
            <div className="incircle">
                <div className="info">
                    <span>{topText}</span>
                    <p></p>
                    <u>{bottomText}<em></em></u>
                </div>
            </div>
        </div>
    );
};
